import { css } from "@emotion/react";
import { bpoints } from "../../Utils";

export function genericHeaderCSS(){
    return css`
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 1.5vw 4vw 1.5vw 4vw; // Top Right Bottom Left

        @media (max-width: ${bpoints.mobile.w}px){
            padding: 3vh 6vw 0 6vw;
        }

        .Container{
            width: 100%;
            //display: grid;
            //grid-template-columns: 1fr 1fr 1fr;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            
            .GridItem{
                //background-color: aliceblue;
                display: flex;
                align-items: center;

                font-size: calc(0.7rem + 0.3vw);
            }

            .Left{
                gap: 2rem;

                span{

                    @media (max-width: ${bpoints.mobile.w}px){
                        display: none;
                    }
                }

                img{
                    width: calc(1.5rem + 9vw);
                    cursor: pointer;

                    @media (max-width: ${bpoints.mobile.w}px){
                        width: calc(3rem + 25vw);
                    }
                }
            }

            .Center{

                .SearchContainer{
                    display: flex;
                    align-items: center;
                    position: relative;
        
                    width: 100%;
        
                    .SearchInput{
                        outline: none;
                        border-radius: 100px;
                        border: double 1px transparent;
                        background-image: linear-gradient(white, white), 
                                            linear-gradient(to right, #204B7B, #32B8DF, #00BA6E);
                        background-origin: border-box;
                        background-clip: padding-box, border-box;
            
                        width: 100%;
                        height: 49px;
        
                        padding-left: calc(1rem + 0.5vw + 1.5rem);
                        padding-right: 1rem;

                        font-size: calc(1rem + 0.2vw);
                    }
        
                    .Icon{
                        position: absolute;
                        left: calc(1rem + 0.5vw);
                    }
                }
            }

            .Right{
                .Nav{
                    display: flex;
                    flex-grow: 1;
                    //justify-content: space-evenly;
                    gap: 2rem;
                    
                    @media (max-width: ${bpoints.mobile.w}px){
                        display: none;
                    }
                    
                    span{
                        cursor: pointer;
                    }

                }

                .SideMenuContainer{
                    display: none;

                    .Icon{
                        font-size: calc(1rem + 4vw);
                        color: #32B8DF;
                    }

                    @media (max-width: ${bpoints.mobile.w}px){
                        display: unset;
                    }

                    .MobileNav{
                        display: flex;
                        flex-direction: column;
                        gap: 2vh;
                        margin-top: 2vh;
                        font-weight: 500;
                        
                        font-size: calc(1rem + 3vw);

                        text-align: right;
                        color: #4a4a4a;
                    }
                }
            }
        }


    `;
}